import { get, post } from './myAxios.js'
import { wasteMap } from '@/utils/map.js'
import _ from 'lodash'
import stamp from './stamp.js'
import seaApplyEvent from './seaApplyEvent.js'
import { sortByKey, searchByKeyword } from '../utils/table.js'
import moment from 'moment'

/**
 * 取得各種海廢數據
 *
 * @returns
 */
export async function getWasteSummary() {
    let res = await get('/waste/summary')
    let statisticsData = {}
    for (let obj of res.data) {
        const city = obj.cityname === 'taiwan' ? '臺灣' : obj.cityname
        statisticsData[city] = {}
        Object.keys(obj).forEach((key) => {
            if (key !== 'cityname') statisticsData[city][wasteMap.get(key)] = obj[key].toFixed(2)
        })
    }
    let updateDate = new Date()
    updateDate.setDate(updateDate.getDate() - 1)
    return { statisticsData, updateDate }
}

const locationArr = ['locationN', 'locationM', 'locationS', 'locationE', 'locationO']
/**
 * 取得海廢活動
 * 當前狀況為本地資料
 *
 * @param {object} query
 * @returns
 */
export async function getBeachActivities(query = {}) {
    let newQuery = {}

    Object.keys(query).forEach((key) => {
        if (locationArr.includes(key)) {
            if (!newQuery.cityName) newQuery.cityName = ''
            else newQuery.cityName += '|'
            newQuery.cityName += query[key]
        } else {
            newQuery[key] = query[key]
        }
    })
    /*
    暫時不從後端拿資料
    let res = await get('/beach/search', newQuery)
    const totalCount = res.data.totalCount
    const beachActivities = res.data.events
    return { totalCount, beachActivities }
    */

    /*
    newQuery = {
        cityName: 'AAA|BBB',
        minParticipateNum: 10,
        maxParticipateNum: 100,
        startDate: 2023/10/01,
        endDate: 2023/10/31,
        keyword: '',
        sort: desc/asc
    }
    */

    // 資料暫時都從本地取用
    if (newQuery.cityName) newQuery.cityName.split('|')
    let beachActivities = []
    for (let obj of seaApplyEvent) {
        if (!moment(obj.startTime)?._isValid) continue
        obj.startTime = moment(obj.startTime).format('YYYY/MM/DD hh:mm')
        let date = obj.startTime.split(' ')[0]
        if (newQuery.cityName && !newQuery.cityName.includes(obj.cityName)) continue
        if (newQuery.minParticipateNum && parseInt(obj.participateNum) < newQuery.minParticipateNum) continue
        if (newQuery.maxParticipateNum && parseInt(obj.participateNum) > newQuery.maxParticipateNum) continue
        if (newQuery.startDate && date < newQuery.startDate) continue
        if (newQuery.endDate && date > newQuery.endDate) continue

        beachActivities.push(obj)
    }

    if (newQuery.keyword) {
        beachActivities = searchByKeyword(beachActivities, newQuery.keyword)
    }

    if (newQuery.orderType === 'asc') {
        sortByKey(beachActivities, 'startTime')
    } else {
        sortByKey(beachActivities, 'startTime', false)
    }

    let totalCount = beachActivities.length
    if (newQuery.pageIndex) beachActivities = beachActivities.splice((newQuery.pageIndex - 1) * 10, newQuery.pageIndex * 10)
    else beachActivities = beachActivities.splice(0, 10)
    return { totalCount, beachActivities }
}

/**
 * 申請加入循環供應鏈
 *
 * @param {object} formData
 */
export async function registerSupplyChain(formData) {
    let myFormData = _.cloneDeep(formData)
    Object.keys(myFormData).forEach((key) => {
        Object.keys(myFormData[key]).forEach((subKey) => {
            if (Array.isArray(myFormData[key][subKey])) {
                // console.log(subKey)
                myFormData[key][subKey] = myFormData[key][subKey].join('|')
            }
        })
    })
    await post('/supplychain/register', myFormData)
}

/**
 * 查詢海費申請進度
 * 當前狀況為本地資料
 *
 * @param {object} query
 * @param {string} query.unitPublishNumber
 * @param {string} query.productName
 * @returns
 */
export async function getProductStampData(query) {
    /* 
    暫時不從後端拿資料
    let res = await get('/productstamp/data', query)
    let arr = []
    for (let item of res.data) {
        if (item.status === 'NoShow') continue
        arr.push(item)
    }
    return arr
    */

    // 資料暫時都從本地取用
    let { unitPublishNumber, productName } = query
    let arr = (function () {
        let newArr = []
        for (let obj of stamp) {
            if (obj.status === 'NoShow') continue
            if (unitPublishNumber && obj.unitPublishNumber.includes(unitPublishNumber)) {
                newArr.push(obj)
                continue
            }
            if (productName) {
                for (let product of obj.products) {
                    if (product.name.includes(productName)) {
                        newArr.push(obj)
                        break
                    }
                }
            }
        }
        return newArr
    })()

    return arr
}

/**
 * 瀏覽人次
 *
 * @returns
 */
export async function getConfigCount() {
    await post('/config/count')
    let res = await get('/config/count')
    const todayViewCount = res.data.today
    const totalViewCount = res.data.total
    return { todayViewCount, totalViewCount }
}
